import { 
    CONTRACT_REQUEST_OBJECT_GET_REQUEST, CONTRACT_REQUEST_OBJECT_GET_SUCCESS, CONTRACT_REQUEST_OBJECT_GET_ERROR, 
    CONTRACT_REQUEST_OBJECT_GET_BY_KEY_REQUEST, CONTRACT_REQUEST_OBJECT_GET_BY_KEY_SUCCESS, CONTRACT_REQUEST_OBJECT_GET_BY_KEY_ERROR, 
    CONTRACT_REQUEST_OBJECT_ADD_REQUEST, CONTRACT_REQUEST_OBJECT_ADD_SUCCESS, CONTRACT_REQUEST_OBJECT_ADD_ERROR, 
    CONTRACT_REQUEST_OBJECT_EDIT_REQUEST, CONTRACT_REQUEST_OBJECT_EDIT_SUCCESS, CONTRACT_REQUEST_OBJECT_EDIT_ERROR, 
    CONTRACT_REQUEST_OBJECT_DELETE_REQUEST, CONTRACT_REQUEST_OBJECT_DELETE_SUCCESS, CONTRACT_REQUEST_OBJECT_DELETE_ERROR
} from "../constants/contractRequestObjectConstants";

const initialState = {
    contractRequestObjects: [],
    contractRequestObject: {},
    loading: false,
    success: null,
    error: null,
    contractRequestObjectRequestedCount: 0,
};

export const contractRequestObjectReducer = (state = initialState, action) => {
    switch (action.type)     {
        case CONTRACT_REQUEST_OBJECT_GET_REQUEST:
            return {
                ...state,
                contractRequestObjectRequestedCount: ++state.contractRequestObjectRequestedCount,
                loading: true,
            };
        case CONTRACT_REQUEST_OBJECT_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                contractRequestObjects: action.payload,
                success: true,
            };
        case CONTRACT_REQUEST_OBJECT_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_REQUEST_OBJECT_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_REQUEST_OBJECT_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                contractRequestObject: action.payload,
                success: true,
            };
        case CONTRACT_REQUEST_OBJECT_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_REQUEST_OBJECT_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_REQUEST_OBJECT_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_REQUEST_OBJECT_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_REQUEST_OBJECT_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_REQUEST_OBJECT_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_REQUEST_OBJECT_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case CONTRACT_REQUEST_OBJECT_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CONTRACT_REQUEST_OBJECT_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case CONTRACT_REQUEST_OBJECT_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
